<script lang="ts">export let width = 18;
export let height = 16;
export let className = "";
export let fill = "white";
</script>

<svg
	{width}
	{height}
	viewBox="0 0 18 16"
	fill="none"
	xmlns="http://www.w3.org/2000/svg"
	class={className}
>
	<path
		d="M18.0009 7.02982V8.96865C18.0009 9.48629 17.6049 9.90982 17.1009 9.92865H15.337C14.365 9.92865 13.474 9.18512 13.393 8.16865C13.339 7.57571 13.555 7.02041 13.933 6.63453C14.266 6.27688 14.725 6.06982 15.229 6.06982H17.1009C17.6049 6.08865 18.0009 6.51218 18.0009 7.02982Z"
		{fill}
	/>
	<path
		d="M16.6228 11.3412H15.3358C13.6259 11.3412 12.1859 9.99529 12.0419 8.28235C11.9609 7.30353 12.3029 6.32471 12.9869 5.62823C13.5629 5.00706 14.3638 4.65882 15.2278 4.65882H16.6228C16.8838 4.65882 17.0998 4.43294 17.0728 4.16C16.8748 1.87294 15.4258 0.310588 13.2749 0.0470588C13.0589 0.00941172 12.8339 0 12.5999 0H4.49995C4.24795 0 4.00496 0.0188235 3.77096 0.0564705C1.47598 0.357647 0 2.14588 0 4.70588V11.2941C0 13.8918 2.01598 16 4.49995 16H12.5999C15.1198 16 16.8568 14.3529 17.0728 11.84C17.0998 11.5671 16.8838 11.3412 16.6228 11.3412ZM9.89989 5.88235H4.49995C4.13096 5.88235 3.82496 5.56235 3.82496 5.17647C3.82496 4.79059 4.13096 4.47059 4.49995 4.47059H9.89989C10.2689 4.47059 10.5749 4.79059 10.5749 5.17647C10.5749 5.56235 10.2689 5.88235 9.89989 5.88235Z"
		{fill}
	/>
</svg>
